<template>
  <transition name="toast-fade">
    <div
      v-if="visible"
      class="toast show bottom-0"
      :class="`bg-${type} text-white`"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">{{ message }}</div>
        <!-- <button type="button" class="ml-2 mb-1 close text-white" @click="closeToast">
          <span>&times;</span>
        </button> -->
        <button type="button" class="btn-close btn-close-white me-2 m-auto p-0" @click="closeToast"></button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toast",
  props: {
    type: { type: String, default: "primary" },
    message: { type: String, required: true },
    duration: { type: Number, default: 3000 },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    requestAnimationFrame(() => {
      this.visible = true;
      this.autoCloseTimer = setTimeout(this.closeToast, this.duration);
    });
  },
  methods: {
    closeToast() {
      this.visible = false;
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
/* Transition name = toast-fade */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.5s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(30px); /* 右侧滑入滑出效果 */
}
</style>



// WEBPACK FOOTER //
// src/components/Toast.vue